module.exports = {
  en: require('./en.json'),
  sw: require('./sw.json'),
  es: require('./es.json')
};
